module.exports = __webpack_public_path__ + "img/ic-menus-glossary.ef2a2f91.svg";